var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58268 18.125C4.87435 18.125 1.04102 14.2917 1.04102 9.58332C1.04102 4.87499 4.87435 1.04166 9.58268 1.04166C14.291 1.04166 18.1243 4.87499 18.1243 9.58332C18.1243 14.2917 14.291 18.125 9.58268 18.125ZM9.58268 2.29166C5.55768 2.29166 2.29102 5.56666 2.29102 9.58332C2.29102 13.6 5.55768 16.875 9.58268 16.875C13.6077 16.875 16.8743 13.6 16.8743 9.58332C16.8743 5.56666 13.6077 2.29166 9.58268 2.29166Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3326 18.9583C18.1742 18.9583 18.0159 18.9 17.8909 18.775L16.2242 17.1083C15.9826 16.8667 15.9826 16.4667 16.2242 16.225C16.4659 15.9833 16.8659 15.9833 17.1076 16.225L18.7742 17.8917C19.0159 18.1333 19.0159 18.5333 18.7742 18.775C18.6492 18.9 18.4909 18.9583 18.3326 18.9583Z",
    fill: "#8D8E92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.68855836a5c93edfef7e31c26783695a.svg";
export { ForwardRef as ReactComponent };